import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { SharedService } from "../helper/shared/shared.service";

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  // webServiceUrl = "https://cfss.camfil.net/CFSSWebService/WebService/";
  // applicationServiceUrl = "https://cfss.camfil.net/CFSSApplicationServicesDev2/WebService/";

  //From Production
  //webServiceUrl = "http://localhost:60101/WebService/";        //local Development
  //applicationServiceUrl = "http://localhost:52488/WebService/"; //local Development

  //webServiceUrl = "https://cfss.camfil.net/CFSSWebServiceDev2/WebService/";
  //applicationServiceUrl = "https://cfss.camfil.net/CFSSApplicationServicesDev2/WebService/";

  //webServiceUrl = "https://cfss.camfil.net/CFSSWebService/WebService/";  // Live
  //applicationServiceUrl = "https://cfss.camfil.net/CFSSApplicationServices/WebService/";   // Live

  //webServiceUrl = "http://SETR-3-77.camfil.dmz/CFSSWebServiceDev2/WebService/";
  //applicationServiceUrl = "http://SETR-3-77.camfil.dmz/CFSSApplicationServicesDev2/WebService/";

  userData = {
    UserId: 0,
    UserName: '',
    UserUnitId: 0,
    UserUnitName: '',
    Company: '',
    Street: '',
    City: '',
    State: '',
    Zip: '',
    Country: '',
    RegionId: 0,
    Region: '',
    Designation: '',
    FullName: '',
    Email: '',
    CurrencyID: 0,
    Currency: '',
    LanguageId: 0,
    AirFlowUnit: '',
    NumberFormat: '',
    NumberFormatId: 0,
    currentLocale: '',
    UserConcUnitId: 0,
    UserConcUnit: ''
  }

  ApplicationID: any = 24;
  unitId_SI = 1;
  unitId_US = 2;
  unit_SI = "SI";
  unit_US = "US";
  FormatDesc_SI = 'European Number Format(123 456,00)';
  FormatDesc_US = 'US / Asian Number Format(123,456.00)';
  selCurrency = '';
  selUnit: any;

  constructor(
    private httpService: HttpClient
  ) { }

  getUserAccountInfo(token: any) {
    //return this.httpService.post(SharedService.webServiceUrl + "RetrieveAccountInfo", { LoginCode: token }); //local
    return this.httpService.post(SharedService.webServiceUrl + "RetrieveAccountInfo", { pLoginCode: { LoginCode: token } });  //live
  }

  InsertUserData(responseObj: any) {
    if (responseObj !== null || responseObj !== undefined) {
      this.userData.UserId = responseObj.ID;
      this.userData.UserName = responseObj.Username;
      this.userData.FullName = responseObj.FullName;
      this.userData.Email = responseObj.Email;
      this.userData.Designation = responseObj.Designation;
      this.userData.UserUnitId = responseObj.UnitID;
      this.userData.UserUnitName = responseObj.Unit;
      this.userData.Company = responseObj.Company;
      this.userData.Street = responseObj.Street;
      this.userData.City = responseObj.City;
      this.userData.State = responseObj.State;
      this.userData.Zip = responseObj.Zip;
      this.userData.Country = responseObj.Country;
      this.userData.RegionId = responseObj.RegionID;
      this.userData.Region = responseObj.Region;
      this.userData.Designation = responseObj.Designation;
      this.userData.CurrencyID = responseObj.CurrencyID;
      this.userData.Currency = responseObj.Currency;
      this.userData.LanguageId = responseObj.LanguageID;
      this.userData.AirFlowUnit = responseObj.AirFlowUnit;
      this.userData.NumberFormatId = responseObj.NumberFormat;

      this.userData.NumberFormatId = Number(responseObj.NumberFormat);

      if (this.userData.NumberFormatId === this.unitId_SI) {
        this.userData.NumberFormat = this.FormatDesc_SI;
        this.userData.currentLocale = 'sv-SE';
      } else {
        this.userData.NumberFormat = this.FormatDesc_US;
        this.userData.currentLocale = 'en-US';
      }

      this.userData.UserConcUnitId = parseInt(responseObj.ConcentrationUnit);

      if (this.userData.UserConcUnitId === 0) {
        this.userData.UserConcUnitId = 1;
      }
      switch (this.userData.UserConcUnitId) {
        case 1:
          this.userData.UserConcUnit = 'ppb';
          break;
        case 2:
          this.userData.UserConcUnit = 'mg/m³';
          break;
      }
    }
  }

  updateUserApplicationUsage(token: string, activity: string): Observable<any> {
    let params = {
      ApplicationID: this.ApplicationID,
      Code: token,
      UserID: this.userData.UserId.toString(),
      Activity: activity,
      Username: this.userData.UserName.toString(),
    };    
    return this.httpService.post(SharedService.applicationServiceUrl_Tieto + "UserApplicationUsageLog", params).pipe(catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return errorMessage;
  }
}
